import { APP_CONFIG } from '@src/core';

export const BASE_PATH_IMAGE = 'api/App/documents/';
export const BASE_PATH_API = `${APP_CONFIG.baseUrl}/${BASE_PATH_IMAGE}`;
